import { type ReactNode } from 'react';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, CircularProgress, type SxProps, type Theme, Typography } from '@mui/material';

import { mutedTextSx } from './analytics.styles';

const { states } = appStrings.modules.coachingAnalytics;

type QueryLike<T> = Readonly<{ data?: T; isError: boolean }>;

type SectionStateProps<T> = Readonly<{
  query: QueryLike<T>;
  children: (data: T) => ReactNode;
}>;

/** Renders its section only once the response is in, with a spinner until then. */
export const SectionState = <T,>({ query, children }: SectionStateProps<T>) => {
  if (query.data) return <>{children(query.data)}</>;

  return (
    <Box sx={placeholderSx}>
      {query.isError ? (
        <Typography variant="text-sm-regular" sx={mutedTextSx}>
          {states.error}
        </Typography>
      ) : (
        <CircularProgress size={24} aria-label={states.loading} />
      )}
    </Box>
  );
};

const placeholderSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  minHeight: 160,
  padding: backrs.spacing['spacing-2xl'],
  borderRadius: backrs.radius['radius-xl'],
  border: `1px solid ${backrs.colors['Colors/Foreground/fg-quinary']}`,
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  boxSizing: 'border-box',
});
